(function () {
  const timers = document.querySelectorAll<HTMLElement>('.js-countdown');
  if (!timers.length) return;

  const pad = (n: number) => String(n).padStart(2, '0');

  timers.forEach((timer) => {
    const target = new Date(timer.dataset.target || '2026-04-14T06:30:00Z').getTime();
    const expiredEl = timer.parentElement?.querySelector<HTMLElement>('.js-countdown-expired');

    const daysEl    = timer.querySelector<HTMLElement>('.js-countdown-days');
    const hoursEl   = timer.querySelector<HTMLElement>('.js-countdown-hours');
    const minutesEl = timer.querySelector<HTMLElement>('.js-countdown-minutes');
    const secondsEl = timer.querySelector<HTMLElement>('.js-countdown-seconds');

    function expire() {
      timer.hidden = true;
      if (expiredEl) expiredEl.hidden = false;
    }

    function tick() {
      const diff = target - Date.now();

      if (diff <= 0) {
        expire();
        return;
      }

      const days    = Math.floor(diff / 86400000);
      const hours   = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (daysEl)    daysEl.textContent    = pad(days);
      if (hoursEl)   hoursEl.textContent   = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    const interval = setInterval(() => {
      if (target - Date.now() <= 0) {
        clearInterval(interval);
        expire();
      } else {
        tick();
      }
    }, 1000);
  });
})();
